// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import Swal from 'sweetalert2';

window.Swal = Swal; // Make it globally accessible
// Set default theme globally

document.addEventListener("turbo:load", function () {
    const flashData = document.body.dataset.flash;

    // Handle flash messages (as in your existing SweetAlert implementation)
    if (flashData) {
        const flash = JSON.parse(flashData);

        if (flash.message) {
            Swal.mixin({
                background: '#000',
                color: '#fff',
                showConfirmButton: true,
                timer: 5000,
                backdrop: false,
            }).fire({
                title: flash.type.charAt(0).toUpperCase() + flash.type.slice(1),
                text: flash.message,
                icon: flash.type === "alert" || flash.type === "error" ? "error" : "success",
            });
            document.body.dataset.flash = ""; // Clear flash data
        }
    }

    // Handle Devise's error messages from resource.errors
    const errorExplanation = document.getElementById("error_explanation");
    if (errorExplanation) {
        const errorData = errorExplanation.dataset.errorMessages;
        if (errorData) {
            const errors = JSON.parse(errorData);

            if (errors.count > 0) {
                Swal.fire({
                    title: "Error" + (errors.count > 1 ? "s" : ""),
                    html: `<ul style="text-align:left;">` +
                        errors.errors.map((err) => `<li>${err}</li>`).join('') +
                        `</ul>`,
                    icon: "error",
                    background: '#000',
                    color: '#fff',
                    showConfirmButton: true,
                    backdrop: true,
                });
            }
        }
    }
});

document.addEventListener("turbo:load", function () {
    requestAnimationFrame(() => {
        const flashData = document.body.dataset.flash;

        if (flashData) {
            const flash = JSON.parse(flashData);

            if (flash.message) {
                Swal.mixin({
                    background: '#000',
                    color: '#fff',
                    showConfirmButton: true,
                    timer: 5000,
                    backdrop: false,
                }).fire({
                    title: flash.type.charAt(0).toUpperCase() + flash.type.slice(1),
                    text: flash.message,
                    icon: flash.type === "alert" || flash.type === "error" ? "error" : "success",
                });
                document.body.dataset.flash = ""; // Clear flash data
            }
        }
    });
});

document.addEventListener('turbo:load', () => {
    // Global event listener for SweetAlert2
    document.addEventListener('keydown', function (event) {
        // Check if SweetAlert2 is visible
        if (Swal.isVisible()) {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent form submission
                Swal.clickConfirm(); // Trigger SweetAlert2's confirm button
            }
        }
    });
});

document.addEventListener("turbo:load", function () {
    // Select all add-role buttons
    const addRoleButtons = document.querySelectorAll(".btn-add-role");

    // Add event listeners to each button
    addRoleButtons.forEach((button) => {
        const userId = button.dataset.userId;

        // Find related dropdown for this user
        const dropdown = document.querySelector(`.role-dropdown[data-user-id='${userId}']`);

        // Add click listener to toggle dropdown visibility
        button.addEventListener("click", function (event) {
            event.stopPropagation(); // Prevent other click events
            dropdown.classList.toggle("active"); // Toggle visibility
        });

        // Close dropdown when clicking outside
        document.addEventListener("click", function (event) {
            if (!dropdown.contains(event.target) && !button.contains(event.target)) {
                dropdown.classList.remove("active");
            }
        });
    });
});

document.addEventListener("turbo:frame-render", () => {
    console.log("Turbo frame rendered. Stimulus should reconnect.");
});

function reinitializeBootstrapDropdowns() {
    document.querySelectorAll('.role-dropdown').forEach(dropdown => {
        new bootstrap.Dropdown(dropdown);
    });
}

// Run this function after Turbo replaces content
document.addEventListener("turbo:load", reinitializeBootstrapDropdowns);
document.addEventListener("turbo:frame-render", reinitializeBootstrapDropdowns);


document.addEventListener("turbo:load", () => {
    const form = document.getElementById("newsletter-form");

    if (form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            const formData = new FormData(form);

            fetch(form.action, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
                },
                body: formData
            })
                .then(response => response.json().then(data => ({ status: response.status, body: data })))
                .then(({status, body}) => {
                    if (status === 201) {
                        Swal.fire({
                            title: 'Subscribed!',
                            text: body.message,
                            icon: 'success',
                            background: '#000',
                            color: '#fff',
                            confirmButtonText: 'Nice!'
                        });
                        form.reset();
                    } else {
                        Swal.fire({
                            title: 'Already Subscribed!',
                            html: body.errors.join('<br>'),
                            icon: 'error',
                            background: '#000',
                            color: '#fff',
                            confirmButtonText: 'Got it'
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Something went wrong. Try again later.',
                        icon: 'error',
                        background: '#000',
                        color: '#fff',
                        confirmButtonText: 'Got it'
                    });
                });
        });
    }
});

document.addEventListener("turbo:load", () => {
    const form = document.getElementById("contact-form");

    if (form) {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            const formData = new FormData(form);

            fetch(form.action, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
                },
                body: formData
            })
                .then(response => response.json().then(data => ({ status: response.status, body: data })))
                .then(({ status, body }) => {
                    if (status === 201) {
                        Swal.fire({
                            title: 'Message Sent!',
                            text: body.message,
                            icon: 'success',
                            background: '#000',
                            color: '#fff',
                            confirmButtonText: 'Awesome!'
                        });
                        form.reset();
                    } else {
                        Swal.fire({
                            title: 'Error',
                            html: body.errors.join('<br>'),
                            icon: 'error',
                            background: '#000',
                            color: '#fff',
                            confirmButtonText: 'Got it'
                        });
                    }
                })
                .catch(() => {
                    Swal.fire({
                        title: 'Oops!',
                        text: 'Something went wrong. Please try again later.',
                        icon: 'error',
                        background: '#000',
                        color: '#fff',
                        confirmButtonText: 'Okay'
                    });
                });
        });
    }
});


